let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1HsGI")).then(() => parcelRequire('jedO8'));